import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { TEXT_KEY, getText } from '../localization';
import { postGuestLogin } from '../../state/query/login';
import { MOUNT_INTENTS } from '../routeParamConstants';
import { getAffId } from '../getAffId';
import store from '../../state/store';
import audio from '../audio';
export var guestLoginHandler = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(updateComponentState, closeTermsModal, addNotification) {
    var aff_id, inviteLinkId;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            updateComponentState({
              isLoading: true
            });
            _context.next = 4;
            return getAffId();

          case 4:
            aff_id = _context.sent;
            inviteLinkId = store.getState().playerInfo.inviteLink;
            _context.next = 8;
            return store.dispatch(postGuestLogin.initiate(_objectSpread(_objectSpread({}, aff_id && {
              aff_id: aff_id
            }), inviteLinkId && {
              inviteLinkId: inviteLinkId
            }))).unwrap();

          case 8:
            _context.next = 15;
            break;

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](0);
            updateComponentState({
              isLoading: false
            });
            closeTermsModal();
            if (typeof _context.t0 !== String) addNotification({
              message: _context.t0.message || _context.t0.data.message,
              title: getText(TEXT_KEY.TRY_AGAIN),
              button: getText(TEXT_KEY.OK)
            });

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 10]]);
  }));

  return function guestLoginHandler(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
export var onGuestActivate = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(termsAccepted, mountIntent, updateComponentState, openModal, closeTermsModal, addNotification) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            audio.onClick();

            if (!(termsAccepted && mountIntent === MOUNT_INTENTS.GUEST_LOGIN)) {
              _context2.next = 6;
              break;
            }

            _context2.next = 4;
            return guestLoginHandler(updateComponentState, closeTermsModal, addNotification);

          case 4:
            _context2.next = 7;
            break;

          case 6:
            openModal(MOUNT_INTENTS.GUEST_LOGIN);

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function onGuestActivate(_x4, _x5, _x6, _x7, _x8, _x9) {
    return _ref2.apply(this, arguments);
  };
}();